'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Observer2 = require('./Observer');

var _Observer3 = _interopRequireDefault(_Observer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClientModel = function (_Observer) {
    _inherits(ClientModel, _Observer);

    /**
     * Name des Mandanten 
     * @type {string}
    */
    function ClientModel(observers, id, request) {
        _classCallCheck(this, ClientModel);

        var _this = _possibleConstructorReturn(this, (ClientModel.__proto__ || Object.getPrototypeOf(ClientModel)).call(this, observers, id, request));

        _this.Description = '';
        _this.Id = '';

        _this.Clients = [];

        return _this;
    }

    /**
     * Id des Mandanten 
     * @type {string}
     */


    _createClass(ClientModel, [{
        key: 'GetClientById',
        value: function GetClientById(id) {
            var me = this;
            this.request.setRequest("/Clients/" + id);
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        if (result.Data[0]) {
                            var data = result.Data[0];
                            me.Id = data.Id;
                            me.Description = data.Description;
                        }
                    }
                }
                var id = me.Id ? me.Id : "Client";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'GetClients',
        value: function GetClients() {
            var me = this;
            this.request.setRequest("/Clients");
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        var clients = [];
                        for (var i = 0; i < result.Data.length; i++) {
                            if (result.Data[i].Description && result.Data[i].Id) {
                                clients.push(result.Data[i]);
                            }
                        }

                        me.Clients = clients;

                        localStorage.setItem("AboCenter", JSON.stringify(clients));
                    }
                }
                var id = me.Id ? me.Id : "Clients";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }]);

    return ClientModel;
}(_Observer3.default);

exports.default = ClientModel;